import React, { memo } from 'react'

import TagsContent from 'Pods/SearchPage/Shared/TagsContent/TagsContent'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import FiltersWrapper from 'Pods/Shared/FiltersWrapper/FiltersWrapper'

// Consolidated stand-in for the inline tag chips + "More" dropdown, shown at 640-1279 where
// the chips no longer fit individually (see .secondary-filters__consolidated).
function Categories() {
  const translate = useTranslate()

  const hasSelectedAnyFilters = useSearchPageStore(state => state.tags.length > 0)

  const content = (
    <div className="tags-filter__dropdown">
      <TagsContent />
    </div>
  )

  return (
    <FiltersWrapper
      placeholder={translate('search_page.filters.categories.title')}
      content={content}
      positionHorizontal="right"
      hasSelectedAnyFilters={hasSelectedAnyFilters}
      closingDropdownClassName="filter-wrapper"
    />
  )
}

export default memo(Categories)
